import React from 'react';
import PropTypes from 'prop-types';

/* import { ReactComponent as PlayPauseIcon } from '../../assets/icons/play-pause.svg'; */
import './style.scss';
import AudioSocialOptions from '../AudioSocialOptions';
import { ReactComponent as Ondas } from '../../assets/icons/ondas.svg';
import { ReactComponent as MenuIcon } from '../../assets/icons/menu-3lines.svg';
import { audioTypesProp } from '../../utils';

const FakePlayer = React.lazy(() => import('../FakePlayer'));

const AudioItem = ({
  date,
  duration,
  desc,
  href,
  title,
  listened,
  modelUrl,
  audioType,
  initialFetch
}) => {
  const getLink = model => {
    if (href) {
      return href;
    }
    const { shareUrl, sociales } = model || {};
    if (shareUrl) {
      return shareUrl;
    }
    if (sociales) {
      return sociales.urlPage;
    }

    return '';
  };
  return (
    <React.Suspense fallback={<div />}>
      <FakePlayer
        modelUrl={modelUrl}
        initialFetch={initialFetch}
        audioType={audioType}
      >
        {({
          handleChange,
          toggleFav,
          isFavourite,
          isLoading,
          isPlaying,
          model
        }) => (
          <li
            className={`audioListItem ${
              isPlaying ? `audioListItem__play ` : `audioListItem__pause `
            }`}
            data-title={desc}
          >
            <div className="MoveIcon">
              <MenuIcon />
            </div>
            <a className="audioListItem-link" href={getLink(model)}>
              <h3 className="audioListItem-title">
                <div>
                  {listened ? (
                    <span className="listened-mobile listened--true">
                      <Ondas />
                    </span>
                  ) : (
                    <span className="listened-mobile listened--false">
                      <Ondas />
                    </span>
                  )}
                </div>
                {duration && (
                  <div>
                    {date && (
                      <span className="audioListItem-date">
                        {date}
                        <span className="audioListItem-dateSeparator">|</span>
                      </span>
                    )}
                    <span className="audioListItem-duration">{duration}</span>
                  </div>
                )}
              </h3>
              {desc && (
                <p className="audioListItem-desc">
                  {listened ? (
                    <span className="listened-desktop listened--true ">
                      <Ondas />
                    </span>
                  ) : (
                    <span className="listened-desktop listened--false ">
                      <Ondas />
                    </span>
                  )}
                  {desc}
                </p>
              )}
            </a>

            <AudioSocialOptions
              title={desc}
              share={{
                shareTitle: title,
                link: getLink(model)
              }}
              onPlay={() => {
                handleChange();
              }}
              onClickFavorite={toggleFav}
              isPlaying={isPlaying}
              favorite={isFavourite}
              isLoading={isLoading}
            />
          </li>
        )}
      </FakePlayer>
    </React.Suspense>
  );
};

AudioItem.propTypes = {
  date: PropTypes.string,
  href: PropTypes.string,
  duration: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  modelUrl: PropTypes.shape().isRequired,
  listened: PropTypes.bool,
  audioType: PropTypes.oneOf(audioTypesProp),
  initialFetch: PropTypes.bool
};

AudioItem.defaultProps = {
  href: undefined,
  date: undefined,
  duration: undefined,
  desc: undefined,
  title: null,
  listened: false,
  audioType: undefined,
  initialFetch: false
};

export default AudioItem;
